import { useNavigate } from 'react-router-dom';
import { useMemo, useState } from 'react';
import { TableColumn } from '../../components/DataTable/TableColumn';
import { TextColumn } from '../../components/DataTable/TextColumn';
import { DateColumn } from '../../components/DataTable/DateColumn';
import { Page } from '../../interfaces/Page/Page';
import { BoolColumn } from '../../components/DataTable/BoolColumn';
import { paginateRows } from '../../utils/Pagination';
import { DataTable } from '../../components/DataTable/DataTable';

const columns: TableColumn<Page>[] = [
  {
    id: 'id',
    name: 'ID',
    accessor: (row) => <TextColumn value={row.id.toString()} />,
  },
  {
    id: 'name',
    name: 'İsim',
    accessor: (row) => <TextColumn value={row.name} />,
  },
  {
    id: 'is-active',
    name: 'Durum',
    accessor: (row) => <BoolColumn value={row.isActive} />,
    align: 'center',
  },
  {
    id: 'created-at',
    name: 'Oluşturulma Tarihi',
    accessor: (row) => <DateColumn value={row.createdAt} />,
  },
  {
    id: 'updated-at',
    name: 'Düzenlenme Tarihi',
    accessor: (row) => <DateColumn value={row.updatedAt} />,
  },
];

type PagesTableProps = {
  pages: Page[];
};

export const PagesTable = (props: PagesTableProps) => {
  const navigate = useNavigate();

  const [pageNumber, setPageNumber] = useState(0);
  const [limit, setLimit] = useState(10);

  const paginatedRows = useMemo(
    () => paginateRows(props.pages, limit, pageNumber),
    [props.pages, limit, pageNumber],
  );

  return (
    <DataTable
      columns={columns}
      totalCount={props.pages.length}
      rows={paginatedRows}
      limit={limit}
      setLimit={setLimit}
      page={pageNumber}
      setPage={setPageNumber}
      onClick={(page) => navigate(`/pages/pages/${page.slug}`)}
    />
  );
};
